<div class="AmStatusPayment-content">
  <div class = "am-full-position">
    <img [src]="url" class="am-full">
  </div>
  <div *ngIf="isRb" class="am-icon-position">
    <img [src]="url2" class="am-icon">
  </div>
  <div [ngClass]="{'AmStatusPayment-content-text--error': type=='error', 'AmStatusPayment-content-text--success': type=='success'}">
    <p class="fs-52px fw-medium-x text-am-white">{{title | translate}}</p>
    <p class="fs-24px fw-regular text-am-white">{{message | translate}} &nbsp;
      <b *ngIf="isRb" class="fs-24px fw-regular text-am-pink-rebrand">{{message2 | translate}}</b>
    </p>
  </div>
</div>

